import React from "react";
import { ChartMenu } from "../../../Chart/Menu";
import ToggleGroupBreaks from "../../../Analysis/ToggleGroupBreaks";
import TogglePublicationDisplay from "../../../Analysis/TogglePublicationDisplay";
import ToggleSuspectedFailuresDisplay from "../../../Analysis/ToggleSuspectedFailuresDisplay";
import type { Project } from "../../../../../api/useProjects";
import { useBreaksBetweenGroups } from "../../../Analysis/useBreaksBetweenGroups";
import type { ActiveAnalysis } from "../../../../../api/useActiveAnalysesStream";
import useSuspectedFailuresInExplanation from "../../useSuspectedFailuresInExplanation";
import t from "../../../../../i18n";

const PeriodMenuDiagnosis = ({
  project,
  activeAnalyses,
  publicationFlagDisplayed,
}: {
  project: Project;
  activeAnalyses: ActiveAnalysis[];
  publicationFlagDisplayed: boolean;
}) => {
  const [breakBetweenGroups] = useBreaksBetweenGroups({
    scope: project.id,
  });

  const [suspectedFailuresDisplay] = useSuspectedFailuresInExplanation({
    scope: project.id,
  });
  return (
    <ChartMenu
      marker={!breakBetweenGroups || publicationFlagDisplayed || suspectedFailuresDisplay}
      tooltipOverlay={t("chart.display_options.tooltip")}
    >
      <TogglePublicationDisplay projectId={project.id} />
      <ToggleGroupBreaks projectId={project.id} groupables={activeAnalyses} />
      <ToggleSuspectedFailuresDisplay projectId={project.id} />
    </ChartMenu>
  );
};

export default PeriodMenuDiagnosis;
